<style lang="scss" scoped>
.sync_schedule {
    &__pad-bottom {
        margin-bottom: 20px;
    }
    &__pad-right {
        padding: 20px;
    }
    &__alert {
        line-height: 1.3em;
    }
}

</style>

<template lang="pug">
.sync_schedule 
    template
        div.sync_schedule
            div.sync_schedule__pad-bottom(v-for="(n, index) in syncSchedulesMax")
                el-switch(v-model='syncSchedules[index].enabled', @change="update")
                span.sync_schedule__pad-right 
                el-time-select(v-model="syncSchedules[index].time" :picker-options="{ start: '00:00',  step: '00:05', end: '23:55' }" placeholder="Select time", :disabled="!syncSchedules[index].enabled", @change="update")
            el-alert.sync_schedule__alert(type="warning" description="Sync times are approximate, and the sync may start up to ten minutes after the nominated time. Depending on the number of changes, a sync can take anywhere from a few seconds to several minutes to complete.")
</template>
<script>
import _ from "lodash";
import moment from "moment";
export default {
    props: {
        persistedSchedules: Array,
        autoSyncTime: String,
    },

    data() {
        return {
            syncSchedulesMax: 4,
            syncSchedules: [],
        }
    },

    created() {
        if (this.persistedSchedules.length < 1) {
            this.syncSchedules = this.initSyncSchedules();
        } else {
            this.syncSchedules = this.formatSyncSchedules(this.persistedSchedules, true);
        }
        this.$emit("input", this.formatSyncSchedules(this.syncSchedules));
    },
    
    methods: {
        initSyncSchedules(start = 1) {
            let syncSchedules = [];
            for (let i = start; i <= this.syncSchedulesMax; i++) {
                syncSchedules.push({
                    enabled: i == 4 && this.autoSyncTime && this.autoSyncTime != "Invalid date" ? true : false,
                    time: i == 4 && this.autoSyncTime && this.autoSyncTime != "Invalid date" ? this.autoSyncTime : null,
                });
            }

            return syncSchedules;
        },
        formatSyncSchedules(syncSchedules, isLocal) {
            const fillSchedules = this.initSyncSchedules(syncSchedules.length + 1);

            syncSchedules = _.concat(syncSchedules, fillSchedules);

            return _(syncSchedules)
                .map((schedule) => {
                    return {
                        enabled: schedule.enabled,
                        time: schedule.time == null ? null : isLocal ? moment.utc(schedule.time, "HH:mm").local().format("HH:mm") : moment(schedule.time, "HH:mm").utc().format("HH:mm")
                    };
                })
                .value()
        },
        update() {
            this.$emit("input", this.formatSyncSchedules(this.syncSchedules));
        },
    }
}

</script>